import React, { useState } from "react";
import PageShell from "../dashboard/PageShell";
import { Calendar, Plus, Trash2 } from "lucide-react";

interface DelegationMember {
  id: number;
  fullName: string;
  dateOfBirth: string;
  gender: string;
  phone: string;
  passportNumber: string;
  expirationDate: string;
  address: string;
  nationality: string;
  organization: string;
  role: string;
  department: string;
}

const AddDelegationMember: React.FC = () => {
  const [members, setMembers] = useState<DelegationMember[]>([
    {
      id: 1,
      fullName: "",
      dateOfBirth: "",
      gender: "",
      phone: "",
      passportNumber: "",
      expirationDate: "",
      address: "",
      nationality: "Việt Nam",
      organization: "Tổ chức 1",
      role: "",
      department: "",
    },
  ]);

  const handleInputChange = (
    index: number,
    field: keyof DelegationMember,
    value: string
  ) => {
    setMembers((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  };

  const addMember = () => {
    const newMember: DelegationMember = {
      id: members.length + 1,
      fullName: "",
      dateOfBirth: "",
      gender: "",
      phone: "",
      passportNumber: "",
      expirationDate: "",
      address: "",
      nationality: "Việt Nam",
      organization: `Tổ chức ${members.length + 1}`,
      role: "",
      department: "",
    };
    setMembers([...members, newMember]);
  };

  const removeMember = (index: number) => {
    if (members.length > 1) {
      setMembers(members.filter((_, i) => i !== index));
    }
  };

  const handleSave = () => {
    console.log("Saving delegation members:", members);
    // TODO: Implement save functionality
  };

  const handleCancel = () => {
    window.history.back();
  };

  return (
    <PageShell title="Thêm thành phần đoàn">
      <div className="space-y-6">
        <div className="mb-6">
          <h1 className="text-xl font-semibold text-gray-800">
            Thêm thành phần đoàn
          </h1>
        </div>

        <div className="bg-white rounded-lg ">
          <div className="overflow-x-auto">
            <table className="min-w-full border-collapse">
              <thead>
                <tr className="bg-gray-50">
                  <th className="border border-gray-300 px-1 py-2 text-sm font-bold text-black text-left w-8">
                    STT
                  </th>
                  <th className="border border-gray-300 px-1 py-2 text-sm font-bold text-black text-left w-32">
                    Họ và tên
                  </th>
                  <th className="border border-gray-300 px-1 py-2 text-sm font-bold text-black text-left w-20">
                    Ngày sinh
                  </th>
                  <th className="border border-gray-300 px-1 py-2 text-sm font-bold text-black text-left w-12">
                    Giới tính
                  </th>
                  <th className="border border-gray-300 px-1 py-2 text-sm font-bold text-black text-left w-16">
                    Điện thoại
                  </th>
                  <th className="border border-gray-300 px-1 py-2 text-sm font-bold text-black text-left w-16">
                    Số hộ chiếu
                  </th>
                  <th className="border border-gray-300 px-1 py-2 text-sm font-bold text-black text-left w-20">
                    Ngày hết hạn
                  </th>
                  <th className="border border-gray-300 px-1 py-2 text-sm font-bold text-black text-left w-20">
                    Địa chỉ
                  </th>
                  <th className="border border-gray-300 px-1 py-2 text-sm font-bold text-black text-left w-16">
                    Quốc tịch
                  </th>
                  <th className="border border-gray-300 px-1 py-2 text-sm font-bold text-black text-left w-16">
                    Tổ chức
                  </th>
                  <th className="border border-gray-300 px-1 py-2 text-sm font-bold text-black text-left w-16">
                    Vai trò
                  </th>
                  <th className="border border-gray-300 px-1 py-2 text-sm font-bold text-black text-left w-20">
                    Phòng ban/đơn vị
                  </th>
                  <th className="border border-gray-300 px-1 py-2 text-sm font-bold text-black text-center w-12">
                    Thao tác
                  </th>
                </tr>
              </thead>
              <tbody>
                {members.map((member, index) => (
                  <tr key={member.id} className="hover:bg-gray-50">
                    <td className="border border-gray-300 px-1 py-2 text-sm text-gray-900 text-center w-8">
                      {index + 1}
                    </td>
                    <td className="border border-gray-300 px-1 py-2 w-32">
                      <input
                        type="text"
                        value={member.fullName}
                        onChange={(e) =>
                          handleInputChange(index, "fullName", e.target.value)
                        }
                        className="w-full px-1 py-1 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Họ và tên..."
                      />
                    </td>
                    <td className="border border-gray-300 px-1 py-2 w-20">
                      <input
                        type="date"
                        value={member.dateOfBirth}
                        onChange={(e) => {
                          const date = new Date(e.target.value);
                          const formattedDate =
                            date.toLocaleDateString("vi-VN");
                          handleInputChange(
                            index,
                            "dateOfBirth",
                            formattedDate
                          );
                        }}
                        className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      />
                    </td>
                    <td className="border border-gray-300 px-1 py-2 w-12">
                      <select
                        value={member.gender}
                        onChange={(e) =>
                          handleInputChange(index, "gender", e.target.value)
                        }
                        className="w-full px-1 py-1 text-sm border border-gray-300 rounded bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      >
                        <option value="">- Giới tính</option>
                        <option value="Nam">Nam</option>
                        <option value="Nữ">Nữ</option>
                      </select>
                    </td>
                    <td className="border border-gray-300 px-1 py-2 w-16">
                      <input
                        type="text"
                        value={member.phone}
                        onChange={(e) =>
                          handleInputChange(index, "phone", e.target.value)
                        }
                        className="w-full px-1 py-1 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Điện thoại..."
                      />
                    </td>
                    <td className="border border-gray-300 px-1 py-2 w-16">
                      <input
                        type="text"
                        value={member.passportNumber}
                        onChange={(e) =>
                          handleInputChange(
                            index,
                            "passportNumber",
                            e.target.value
                          )
                        }
                        className="w-full px-1 py-1 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Số hộ chiếu..."
                      />
                    </td>
                    <td className="border border-gray-300 px-1 py-2 w-20">
                      <input
                        type="date"
                        value={member.expirationDate}
                        onChange={(e) => {
                          const date = new Date(e.target.value);
                          const formattedDate =
                            date.toLocaleDateString("vi-VN");
                          handleInputChange(
                            index,
                            "expirationDate",
                            formattedDate
                          );
                        }}
                        className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      />
                    </td>
                    <td className="border border-gray-300 px-1 py-2 w-20">
                      <input
                        type="text"
                        value={member.address}
                        onChange={(e) =>
                          handleInputChange(index, "address", e.target.value)
                        }
                        className="w-full px-1 py-1 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Địa chỉ"
                      />
                    </td>
                    <td className="border border-gray-300 px-1 py-2 w-16">
                      <select
                        value={member.nationality}
                        onChange={(e) =>
                          handleInputChange(
                            index,
                            "nationality",
                            e.target.value
                          )
                        }
                        className="w-full px-1 py-1 text-sm border border-gray-300 rounded bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      >
                        <option value="Việt Nam">Việt Nam</option>
                        <option value="Mỹ">Mỹ</option>
                        <option value="Nhật Bản">Nhật Bản</option>
                        <option value="Hàn Quốc">Hàn Quốc</option>
                      </select>
                    </td>
                    <td className="border border-gray-300 px-1 py-2 w-16">
                      <input
                        type="text"
                        value={member.organization}
                        onChange={(e) =>
                          handleInputChange(
                            index,
                            "organization",
                            e.target.value
                          )
                        }
                        className="w-full px-1 py-1 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      />
                    </td>
                    <td className="border border-gray-300 px-1 py-2 w-16">
                      <select
                        value={member.role}
                        onChange={(e) =>
                          handleInputChange(index, "role", e.target.value)
                        }
                        className="w-full px-1 py-1 text-sm border border-gray-300 rounded bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      >
                        <option value="">- Vai trò</option>
                        <option value="Trưởng đoàn">Trưởng đoàn</option>
                        <option value="Phó đoàn">Phó đoàn</option>
                        <option value="Thành viên">Thành viên</option>
                      </select>
                    </td>
                    <td className="border border-gray-300 px-1 py-2 w-20">
                      <select
                        value={member.department}
                        onChange={(e) =>
                          handleInputChange(index, "department", e.target.value)
                        }
                        className="w-full px-1 py-1 text-sm border border-gray-300 rounded bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      >
                        <option value="">- Phòng ban/đơn vị</option>
                        <option value="Phòng Kế hoạch">Phòng Kế hoạch</option>
                        <option value="Phòng Tài chính">Phòng Tài chính</option>
                        <option value="Phòng Nhân sự">Phòng Nhân sự</option>
                      </select>
                    </td>
                    <td className="border border-gray-300 px-1 py-2 text-center w-12">
                      <button
                        type="button"
                        onClick={() => removeMember(index)}
                        className="p-1 text-red-500 hover:text-red-700 hover:bg-red-50 rounded transition-colors"
                        title="Xóa thành viên"
                        disabled={members.length === 1}
                      >
                        <Trash2 className="h-4 w-4" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Add Member Button */}
          <div className="p-4 border-t border-gray-200">
            <button
              type="button"
              onClick={addMember}
              className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 transition-colors"
            >
              <Plus className="h-4 w-4" />
              Thêm thành viên
            </button>
          </div>
        </div>

        {/* Form Actions */}
        <div className="flex items-center justify-end gap-2">
          <button
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded hover:bg-gray-50"
            onClick={handleCancel}
          >
            Hủy
          </button>
          <button
            className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded text-sm font-medium"
            onClick={handleSave}
          >
            Lưu dữ liệu
          </button>
        </div>
      </div>
    </PageShell>
  );
};

export default AddDelegationMember;
